<template>
    <div class="row" v-if="posicao">

        <div class="col-sm-6">
            <posicao-atual :posicao="posicao"/>

            <google-maps-button :long="posicao.long" :lat="posicao.lat" />
            <!--<google-earth-button :long="posicao.long" :lat="posicao.lat" />-->
            <google-street-view-button :long="posicao.long" :lat="posicao.lat" />

            <!--
            <button class="btn btn-success">
                NOVA ORDEM DE SERVIÇO
            </button>
            -->
        </div>
        <div class="col-sm-6">
            <map-posicao :height="'calc(100vh - 290px)'" :posicao="posicao"/>
            <!--<map-component :height="'calc(100vh - 260px)'"  :posicao="posicao"></map-component>-->
        </div>
    </div>
</template>

<script>
import PosicaoAtual from './PosicaoAtual.vue';
import GoogleMapsButton from '../../buttons/GoogleMapsButton.vue';
import GoogleEarthButton from '../../buttons/GoogleEarthButton.vue';
import MapPosicao from './MapPosicao.vue';
import GoogleStreetViewButton from '../../buttons/GoogleStreetViewButton.vue';

export default {
    name: 'PositionsMaps',
    components: {GoogleStreetViewButton, MapPosicao, GoogleEarthButton, GoogleMapsButton, PosicaoAtual},
    props: {
        posicao: {
            required: true,
            default: null
        }
    }
};
</script>
